import React from "react";

const SuggestionIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="30"
    height="21"
    viewBox="0 0 30 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.4154 10.9023C12.199 10.9023 14.452 8.6493 14.452 5.86569C14.452 3.08207 12.199 0.829102 9.4154 0.829102C6.63178 0.829102 4.37881 3.08207 4.37881 5.86569C4.37881 8.6493 6.63178 10.9023 9.4154 10.9023ZM12.8691 12.3413H12.4958C11.5604 12.791 10.5216 13.0608 9.4154 13.0608C8.30915 13.0608 7.27485 12.791 6.33498 12.3413H5.96174C3.10168 12.3413 0.78125 14.6617 0.78125 17.5218V18.8169C0.78125 20.0086 1.74809 20.9754 2.93979 20.9754H15.891C17.0827 20.9754 18.0495 20.0086 18.0495 18.8169V17.5218C18.0495 14.6617 15.7291 12.3413 12.8691 12.3413ZM22.3666 10.9023C24.75 10.9023 26.6837 8.96858 26.6837 6.5852C26.6837 4.20181 24.75 2.26813 22.3666 2.26813C19.9832 2.26813 18.0495 4.20181 18.0495 6.5852C18.0495 8.96858 19.9832 10.9023 22.3666 10.9023ZM24.5252 12.3413H24.3543C23.7292 12.5571 23.0681 12.7011 22.3666 12.7011C21.6651 12.7011 21.004 12.5571 20.379 12.3413H20.2081C19.2907 12.3413 18.4453 12.6066 17.7033 13.0338C18.8005 14.2165 19.4886 15.786 19.4886 17.5218V19.2486C19.4886 19.3475 19.4661 19.442 19.4616 19.5364H27.4032C28.5949 19.5364 29.5617 18.5696 29.5617 17.3779C29.5617 14.5943 27.3088 12.3413 24.5252 12.3413Z"
      fill="currentColor"
    />
  </svg>
);

export default SuggestionIcon;
